import * as React from "react";
import { SVGProps } from "react";
function SvgMeetingPauseRecIcon(props: SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M6 19h4V5H6v14Zm8-14v14h4V5h-4Z" fill="#16A085" />
    </svg>
  );
}
export default SvgMeetingPauseRecIcon;
